import React from 'react';
import BasicCalloutWrapper from '../../../shared/components/BasicCalloutWrapper/BasicCalloutWrapper';

const HomepageMarketing = () => (
  <BasicCalloutWrapper
    openNewTab
    titleText='Looking for Business Solutions?'
    subText='FlightStats, part of FlightGlobal, is the leading provider of real-time global flight data to companies and individuals across the travel ecosystem.'
    buttonLabel='VIEW PRODUCTS'
    onClickURL='https://www.flightstats.com/company/products/'
    onClickGALabel='HomepageMarketingViewProducts'
  />
);

export default HomepageMarketing;



// WEBPACK FOOTER //
// ./modules/Homepage/components/Marketing.js